export default "__VITE_ASSET__CKMz5q2___"